import { NgClass } from '@angular/common';
import { Component } from '@angular/core';

interface DemoBadgeCorner {
  /** Stable key for tracking / test ids. */
  key: string;
  /** Fixed-position classes for the badge wrapper. */
  badge: string;
  /** Position classes for the tooltip, flipped to open toward screen centre. */
  tip: string;
}

/**
 * Demo/staging indicator (backend DEMO_ENVIRONMENT=true, surfaced via the
 * app-init frontend config). Shown to EVERYONE on every layout — gated only by
 * the demo flag in app.component.html.
 *
 * Renders a small fixed badge in ALL FOUR corners; hovering or focusing any one
 * reveals the full warning that — despite being a demo — outbound integrations
 * are LIVE: real Zoom meetings get created and real emails are delivered through
 * the (test) Brevo account. Fixed + tiny, so they need no layout offset and
 * never collide with the header.
 */
@Component({
  selector: 'app-demo-environment-banner',
  templateUrl: './demo-environment-banner.component.html',
  imports: [NgClass],
})
export class DemoEnvironmentBannerComponent {
  // Full class strings (not constructed) so Tailwind's scanner keeps them.
  readonly corners: readonly DemoBadgeCorner[] = [
    { key: 'tl', badge: 'left-2 top-2', tip: 'left-0 top-full mt-2 origin-top-left' },
    { key: 'tr', badge: 'right-2 top-2', tip: 'right-0 top-full mt-2 origin-top-right' },
    { key: 'bl', badge: 'left-2 bottom-2', tip: 'left-0 bottom-full mb-2 origin-bottom-left' },
    { key: 'br', badge: 'right-2 bottom-2', tip: 'right-0 bottom-full mb-2 origin-bottom-right' },
  ];
}
